export default {
	'add-vehicle': 'Add vehicle',
	'edit-vehicle': 'Edit vehicle',
	'reconnect-gps': 'Reconnect with gps divides',
	'confirm-reconnecting-gps': 'Confirm reconnecting',
	'confirm-reconnecting-message': 'Are you sure you want to reconnect with gps devices?',
}